/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getBooleanDecoder,
  getBooleanEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type AccessAuditConfig = {
  auditEnabled: boolean;
  realTimeMonitoring: boolean;
  retentionPeriod: bigint;
};

export type AccessAuditConfigArgs = {
  auditEnabled: boolean;
  realTimeMonitoring: boolean;
  retentionPeriod: number | bigint;
};

export function getAccessAuditConfigEncoder(): FixedSizeEncoder<AccessAuditConfigArgs> {
  return getStructEncoder([
    ["auditEnabled", getBooleanEncoder()],
    ["realTimeMonitoring", getBooleanEncoder()],
    ["retentionPeriod", getI64Encoder()],
  ]);
}

export function getAccessAuditConfigDecoder(): FixedSizeDecoder<AccessAuditConfig> {
  return getStructDecoder([
    ["auditEnabled", getBooleanDecoder()],
    ["realTimeMonitoring", getBooleanDecoder()],
    ["retentionPeriod", getI64Decoder()],
  ]);
}

export function getAccessAuditConfigCodec(): FixedSizeCodec<
  AccessAuditConfigArgs,
  AccessAuditConfig
> {
  return combineCodec(
    getAccessAuditConfigEncoder(),
    getAccessAuditConfigDecoder(),
  );
}
